// extracted by mini-css-extract-plugin
export default {"container":"SuperAdmin_container__ovwSY","childContainer":"SuperAdmin_childContainer__J+7bv","adminPanel":"SuperAdmin_adminPanel__-iMGC"};